const normalizePartialPaymentOption = (value) => (value === '预付款' ? '固定金额' : value);

export const formatPaymentScheduleHeading = (paymentMethod, prePaymentOption) => {
	const method = paymentMethod ?? '';
	if (!method) return '财务';
	if (method !== '部分支付') return `财务 | ${method}`;
	const kind = normalizePartialPaymentOption(prePaymentOption) || '百分比';
	return `财务 | ${method}（${kind}）`;
};

/** 付款金额输入：去掉前导 0，保留 0. 和小数末尾的 0。 */
export const normalizeAmountText = (raw) => {
	let text = String(raw ?? '').replace(/[^\d.]/g, '');
	const dot = text.indexOf('.');
	if (dot >= 0) {
		text = `${text.slice(0, dot + 1)}${text.slice(dot + 1).replace(/\./g, '')}`;
	}
	text = text.replace(/^0+(?=\d)/, '');
	if (text === '' || text === '.') return text === '.' ? '0.' : '0';
	if (text.startsWith('.')) return `0${text}`;
	return text;
};
